export default __webpack_public_path__ + "fonts/CashBuyer-White.svg";